import { apiFetch } from "../api.js";
import type {
  CreateMessageInput,
  CreateMessageThreadInput,
  Message,
  MessageThread,
  MessageThreadsListResponse,
  MessagesListResponse,
  UpdateMessageThreadInput,
} from "./types.js";

/**
 * Messages + threads API module — Phase 4 Session 2.
 *
 * Threads carry the caller's `unread_count` (derived server-side from
 * `unread_count_by_user[caller.user_id]`); the SPA polls
 * `listMessageThreads()` every 60s for the dashboard nav badge.
 *
 * Messages are append-only in v1: no edit/delete endpoints.
 */

export function listMessageThreads(): Promise<MessageThreadsListResponse> {
  return apiFetch<MessageThreadsListResponse>("/v1/message-threads");
}

export function createMessageThread(
  input: CreateMessageThreadInput,
): Promise<MessageThread> {
  return apiFetch<MessageThread>("/v1/message-threads", {
    method: "POST",
    body: JSON.stringify(input),
  });
}

export function updateMessageThread(
  threadId: string,
  input: UpdateMessageThreadInput,
): Promise<MessageThread> {
  return apiFetch<MessageThread>(
    `/v1/message-threads/${encodeURIComponent(threadId)}`,
    {
      method: "PATCH",
      body: JSON.stringify(input),
    },
  );
}

export function listMessages(threadId: string): Promise<MessagesListResponse> {
  return apiFetch<MessagesListResponse>(
    `/v1/message-threads/${encodeURIComponent(threadId)}/messages`,
  );
}

export function postMessage(
  threadId: string,
  input: CreateMessageInput,
): Promise<Message> {
  return apiFetch<Message>(
    `/v1/message-threads/${encodeURIComponent(threadId)}/messages`,
    {
      method: "POST",
      body: JSON.stringify(input),
    },
  );
}

export function markThreadRead(threadId: string): Promise<void> {
  return apiFetch<void>(
    `/v1/message-threads/${encodeURIComponent(threadId)}/read`,
    { method: "POST" },
  );
}
